let uid = 0;

export default function Id() {
  return '_el_' + uid++;
}